import React, { useState } from 'react';

import { PageSkeleton } from "../components/PageSkeleton";
import { useParams } from 'react-router-dom';
import { staffMembers } from '../utils/utils.statiquedata';
import { apiGet } from '../utils/api';
import { truncateText } from '../utils/utils.fucntions';
import { Hrseparator } from '../components/subcomponents/Hrseparator';
import { ContactLink } from '../components/subcomponents/ContactComponent';
import { ProfileCard } from '../components/subcomponents/ProfileCard';
import { PageSectionHeader } from '../components/subcomponents/PageSectionHeader';
import { BreadcrumbProfile } from '../components/subcomponents/BreadcrumpProfile';

export const Profile: React.FC = () => {
    const { profile } = useParams<{ profile: string }>();
    const [item, setItem] = useState<StaffMember | null>(null);

    React.useEffect(() => {
        let active = true;
        const fallback = staffMembers.find(c => c.slug === profile) || null;
        apiGet(`/staff/${profile}`)
            .then((d) => {
                if (active) setItem(d?.item || fallback);
            })
            .catch(() => { if (active) setItem(fallback); });
        return () => { active = false; };
    }, [profile]);

    if (!item) {
        return <PageSkeleton />;
    }

    const { name, role, description, email, extra, phone } = item;

    return (
        <>
            <div className="container page-content py-5">
                <BreadcrumbProfile
                    category={name ?? ""}
                    profile_name={truncateText(name ?? "", 100)}
                />
                <PageSectionHeader
                    eyebrow={role ?? "Profil"}
                    title={name ?? ""}
                    lead={description}
                    align="start"
                    headingLevel="h1"
                />

                {/* ----- */}

                <div className="row">
                    <aside className="col-md-4 pe-md-5">
                        <ProfileCard
                            profile={item}
                            showDescription={false}
                            variant="sidebar"
                        />
                        {/* <SocialShare
                            post_name={slug ?? ""}
                        /> */}
                        {/* 
                        <div className="mt-5 pt-5">
                            <h2 className="h4 fw-bold mb-3">Autres centres de recherche</h2>
                            <hr className="mb-3" />
                            <ul className="list-unstyled">
                                {centers.filter(c => c.flug !== center).map((center, idx) => (
                                    <li key={idx} className="mb-2"><a href={center.href} className="text-decoration-none text-dark">{center.title}</a></li>
                                ))}
                            </ul>
                        </div> */}
                    </aside>

                    <main className="col-md-8">
                        <article className="entry-content">
                            <div
                                className="prose lead-"
                                dangerouslySetInnerHTML={{ __html: description ?? "" }}
                            />
                            {/* Bibliographie */}
                            <hr className="my-4" style={{ opacity: 0.1 }} />
                            <h2 className="h4 fw-bold mb-3">Bibliographie</h2>
                            <div
                                className="prose lead-"
                                dangerouslySetInnerHTML={{ __html: extra?.bibliography ?? "" }}
                            />
                            {/* Domaines de recherche */}
                            <hr className="my-4" style={{ opacity: 0.1 }} />
                            <h2 className="h4 fw-bold mb-3">Domaines de recherche</h2>
                            <ul>
                                {extra?.researchInterests?.map(etude => {
                                    return (<li>{etude}</li>);
                                })}
                            </ul>
                            {/* Publications */}
                            <hr className="my-4" style={{ opacity: 0.1 }} />
                            <h2 className="h4 fw-bold mb-3">Publications</h2>
                            <ul>
                                {extra?.publications?.map(partenaire => {
                                    return (<li>{partenaire}</li>);
                                })}
                            </ul>
                            {/* Contacts */}
                            <hr className="my-4" style={{ opacity: 0.1 }} />
                            <h2 className="h4 fw-bold mb-3">Contacts</h2>
                            <ul>
                                {email?.map(contact => {
                                    return (<li><ContactLink value={contact} /></li>);
                                })}
                            </ul>
                            <ul>
                                {phone?.map(contact => {
                                    return (<li><ContactLink value={contact} /></li>);
                                })}
                            </ul>
                        </article>
                    </main>
                </div>
                <Hrseparator />
            </div>
        </>
    );
}